<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div>
          <div class="table-responsive">
            <table
              class="
                table
                project-list-table
                table-nowrap table-centered table-borderless
              "
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 100px" colspan="4">
                    <h5 class="p-2">{{ $t("verification.sign-dashboard") }}</h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <router-link
                      to="/profile/setting/two-step-verification"
                      class="btn-block text-muted"
                    >
                      {{ $t("verification.two-step-verification") }}
                    </router-link>
                  </td>
                  <td>
                    <span
                      v-if="user_profile.last_update_2fa"
                      class="text-success"
                      >{{ $t("verification.last-updated") }} <br />
                      <span class="text-muted">{{
                        formatDate(user_profile.last_update_2fa)
                      }}</span></span
                    >
                    <span v-else> - </span>
                  </td>
                  <td>
                    <span v-if="user_profile.is_active_2fa && !loading">
                      <i
                        class="
                          fas
                          fa-check-circle
                          mr-2
                          text-success
                          font-size-18
                        "
                      >
                      </i>
                      <span class="font-size-14">On </span></span
                    >
                    <span v-if="!user_profile.is_active_2fa && !loading">
                      <i class="fas fa-ban mr-2 text-light font-size-18"> </i>
                      <span class="font-size-14">Off </span></span
                    >
                  </td>
                  <td class="text-right" width="10%">
                    <h5 class="text-truncate font-size-14">
                      <router-link
                        to="/profile/setting/two-step-verification"
                        class="btn-block"
                      >
                        <i class="fa fa-chevron-right text-white mr-2"> </i>
                      </router-link>
                    </h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <router-link
                      to="/profile/setting/two-step-verification"
                      class="btn-block text-muted"
                    >
                      {{ $t("verification.change-password") }}
                    </router-link>
                  </td>

                  <td>-</td>
                  <td>-</td>
                  <td class="text-right" width="10%">
                    <h5 class="text-truncate font-size-14">
                      <router-link
                        to="/profile/change-password"
                        class="btn-block"
                      >
                        <i class="fa fa-chevron-right text-white mr-2"> </i>
                      </router-link>
                    </h5>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/user.service";
import appConfig from "@/app.config";
import moment from "moment";
import { revenueChart } from "./data-profile";
import Stat from "@/components/widgets/stat";
import { required } from "vuelidate/lib/validators";
import { userService } from "@/helpers/authservice/user.service";
import Vue from "vue";

export default {
  page: {
    title: "Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Stat },
  data() {
    return {
      refresh_token: 0,
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      revenueChart: revenueChart,
      title: "Profile",
      image_avatar: "",
      submitted: false,
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Profile",
          href: "/profile",
        },
        {
          text: this.$t("malware.setting"),
          active: true,
        },
      ],
      loading: false,
      user_profile: {
        id_user: "",
        username: "",
        email: "",
        name: "",
        role: "",
        avatar: "",
        last_login: "",
        is_active_2fa: "",
        last_update_2fa: "",
        created_at: "",
        updated_at: "",
      },
    };
  },
  validations: {
    user_profile: {
      name: { required },
      email: { required },
      username: { required },
    },
  },

  mounted() {
    this.getUser();
  },
  methods: {
    getUser() {
      let ferr = 0;
      this.loading = true;
      UserService.profileUser()
        .then((response) => {
          if (response.status == 201) {
            let new_token = response.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getUser();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            let val = response.data.data;
            this.user_profile.id_user = val.id_user;
            this.user_profile.username = val.username;
            this.user_profile.email = val.email;
            this.user_profile.name = val.name;
            this.user_profile.role = val.role ?? "-";
            this.user_profile.avatar = val.avatar ?? "";
            this.user_profile.last_login = val.last_login ?? "-";
            this.user_profile.is_active_2fa = val.is_active_2fa;
            this.user_profile.last_update_2fa = val.last_update_2fa;
            this.user_profile.created_at = this.formatDate(val.created_at);
            this.user_profile.updated_at = this.formatDate(val.updated_at);
            this.loading = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getUser();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log(err);
              this.loading = false;
            }
          }
        });
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  },
};
</script>      